import React, { useEffect, useState } from 'react';
import { MessageAttachment } from 'amazon-chime-sdk-component-library-react';
import { AttachmentService } from '../../services/AttachmentService';
import defaultImage from '../../assets/default-img.jpg';
import AWS from 'aws-sdk';

interface AttachmentProps {
    fileKey: string,
    name: string,
    size: string,
    isImage: boolean
    isScanResult?: boolean;
    versionId?: string
}

const Attachment = ({ fileKey, name, size = "0", isImage, isScanResult, versionId }: AttachmentProps) => {
    const [url, setUrl] = useState(defaultImage);
    const [downUrl, setDownUrl] = useState("");

    useEffect(() => {
        if (isScanResult && versionId && versionId !== "") {
            name = name + `/${versionId}`;
        }

        let downloadLink = `${process.env.REACT_APP_API_KEY_PCS}${isScanResult ? `/api/Document/DownloadFileScanResult/` : `/api/Document/DownloadFile/`}` + fileKey +
            `/${name}`;

        setDownUrl(
            downloadLink
        );

        async function getUrl() {
            const attachmentService = AttachmentService.getInstance();
            const data = await attachmentService.getPresignURL(fileKey);
            setUrl(data);
        }
        if (AWS.config.credentials) {
            getUrl();
        }

    }, [fileKey, AWS.config.credentials]);


    return (
        <MessageAttachment
            renderImg={isImage}
            name={name}
            downloadUrl={downUrl}
            size={size}
            imgUrl={url}
        />
    );
};

export default Attachment;
